define('shoptheme/components/blocks/csp/detail/firmware-accordion',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
], function(
	$,
	Component,
	BEM
) {
	return Component.create({

		blocks: null,

		$init: function() {


			this.blocks = BEM.block('csp-support-detail-firmware');
			this.blocks.each(function() {

				var block = BEM.block(this);
				var list = block.getElements("list");
				var items = block.getElements("list-item");
				var headlines = block.getElements("headline");

				headlines.click(function(event){
					event.preventDefault();

					//items.removeClass('active');

					if ($(this).parents('.b_csp-support-detail-firmware__list-item').hasClass('active')) {
						//already opened, then close
						$(this).parents('.b_csp-support-detail-firmware__list-item').removeClass('active');
					}
					else {
						$(this).parents('.b_csp-support-detail-firmware__list-item').addClass('active');
					}


					setHeight();

				});

				function setHeight() {
					/*
					var height = block.height();
					var tabHeight = block.parents('.b_tabs__tab-content.b_tabs__tab-content--active').outerHeight(true);
					var tabs = block.parents('.b_tabs');
					tabs.css('height', 'auto');
					tabs.css('min-height', tabHeight);
					*/

					block.trigger("gigaset.content.change");

				}

			});

		}

	});
});
